import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DataService } from 'src/app/shared/network/data.service';
import { ColumnForSelection } from 'src/app/shared/import/column-for-selection';
import { BaseColumnSelectComponent } from '../base-column-selection.component';
import { ProjectService } from 'src/app/shared/project/project.service';
import { ImportProgressService } from 'src/app/shared/import/import-progress.service';
import { ImportStep } from 'src/app/shared/import/import-step';

@Component({
  templateUrl: './outcome-column-selection.component.html',
  styleUrls: ['../../general.scss', '../column-selection.scss']
})
export class OutcomeColumnSelectComponent extends BaseColumnSelectComponent implements OnInit {
    projectId: string;
    columns: ColumnForSelection[];
    selectedColumn: ColumnForSelection;
    formula: string;

    loading = false;
    dataLoaded = false;
    refineFormula = false;
    selectingOutcome = false;

    constructor(private dataService: DataService, private activatedRoute: ActivatedRoute,
        private router: Router, private projectService: ProjectService, private importProgressService: ImportProgressService)
    {
        super();
    }

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((queryParams: any) => {
            let projectId = queryParams.projectId;
            if(projectId) {
                this.projectId = projectId;
                this.projectService.setProjectId(projectId);
                this.dataService.get<any>('columnSelection/outcome/' + projectId)
                    .then(resp => {
                        this.columns = resp.columns;
                        this.formula = resp.formula;
                        this.selectColumn(resp.columns.filter(c => c.isSelected)[0]);
                        this.highlightMentionedFormulaComponents();
                        this.dataLoaded = true;
                    });
            }
        });
    }

    public columnClicked(column: ColumnForSelection): void {
        if (!column || !column.isEligible) {
            return;
        }
        if(this.selectingOutcome) {
            this.selectOutcomeColumn(column);
        } else {
            this.addColumnToFormula(column);
        }
    }

    private selectOutcomeColumn(column: ColumnForSelection): void {
        for (var i = 0; i < this.columns.length; ++i) {
            this.columns[i].isSelected = false;
        }
        column.isSelected = true;
        this.selectedColumn = column;
        this.formula = this.replaceAll(this.formula, '[' + column.name + ']', '1');
        this.selectingOutcome = false;
        this.highlightMentionedFormulaComponents();
    }

    private addColumnToFormula(column: ColumnForSelection): void {
        if(column.isSelected) {
            return;
        }
        let columnNameBracketed = '[' + column.name + ']';
        if (this.formula.indexOf(columnNameBracketed) >= 0) {
            return;
        }
        let str = '';
        if (this.formula) {
            str += ' * ';
        }
        this.formula += str + columnNameBracketed;
        this.highlightMentionedFormulaComponents();
    }

    private replaceAll(str: string, find: string, replace: string) {
        return str.split(find).join(replace);
    }

    formulaChanged() {
        this.highlightMentionedFormulaComponents();
    }

    async save() {
        if(this.loading) {
            return;
        }
        try {
            this.loading = true;
            await this.dataService.post('columnSelection/outcome', {
                projectId: this.projectId,
                columnIndex: this.columns.indexOf(this.selectedColumn),
                formula: this.formula,
            });
            this.refineFormula = false;
            this.importProgressService.setImportStep(ImportStep.outcomeColumn);
            this.router.navigateByUrl('/select-column-existence?projectId=' + this.projectId);
        }
        catch (ex) {
            this.refineFormula = true;
        }
        finally {
            this.loading = false;
        }
    }

    async noformula() {
        if(this.loading) {
            return;
        }
        try {
            this.loading = true;
            await this.dataService.post('columnSelection/outcomeNoFormula', {
                projectId: this.projectId,
                columnIndex: this.columns.indexOf(this.selectedColumn)
            });
            this.router.navigateByUrl('/identities?projectId=' + this.projectId);
        } finally {
            this.loading = false;
        }
    }

    private highlightMentionedFormulaComponents() {
        let formula = this.formula.toLowerCase();
        for (let i = 0;i < this.columns.length; ++i) {
            this.columns[i].mentionedInFormula = formula.indexOf('[' + this.columns[i].name.toLowerCase() + ']') >= 0
                                              || formula.indexOf('[@' + this.columns[i].name.toLowerCase() + ']') >= 0
                                              || formula.indexOf('[@[' + this.columns[i].name.toLowerCase() + ']]') >= 0;
        }
    }
    
}
